import { useEffect } from 'react';
import { useWizard } from '../../context/WizardContext';
import { Input } from '../UI/Input';
import { Button } from '../UI/Button';
import { ArrowRight, ArrowLeft } from 'lucide-react';

export function ContactStep() {
  const { state, updateFormData, nextStep, prevStep, setError, clearError } = useWizard();
  const { contact } = state.formData;

  useEffect(() => {
    const email = contact?.email || '';
    const phone = contact?.phone || '';
    
    if (!email.trim()) {
      setError('contact', 'El correo electrónico es obligatorio.');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('contact', 'Ingresa un correo electrónico válido.');
      return;
    }

    if (phone && !/^\d{10,15}$/.test(phone.replace(/\D/g, ''))) {
      setError('contact', 'El teléfono debe tener entre 10 y 15 dígitos.');
      return;
    }

    clearError('contact');
  }, [contact, setError, clearError]);

  const handleChange = (field: keyof typeof contact, value: string) => {
    updateFormData({
      contact: {
        ...contact,
        [field]: value,
      },
    });
  };

  return (
    <div className="max-w-2xl mx-auto animate-fade-in">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Datos de contacto
        </h2>
        <p className="text-gray-600">
          Proporciona tus datos de contacto para recibir actualizaciones sobre tu factura.
        </p>
      </div>

      <div className="space-y-6">
        <Input
          label="Correo electrónico *"
          type="email"
          placeholder="ejemplo@correo.com"
          value={contact?.email || ''}
          onChange={(e) => handleChange('email', e.target.value)}
          error={state.errors.contact?.includes('correo') ? state.errors.contact : undefined}
          required
        />

        <Input
          label="Teléfono (opcional)"
          type="tel"
          placeholder="Ej: 5512345678"
          value={contact?.phone || ''}
          onChange={(e) => handleChange('phone', e.target.value)}
          helper="10-15 dígitos, sin espacios ni guiones"
        />

        <Input
          label="Nombre (opcional)"
          placeholder="Tu nombre completo"
          value={contact?.name || ''}
          onChange={(e) => handleChange('name', e.target.value)}
          helper="Como aparecerá en la factura"
        />
      </div>

      <div className="flex justify-between items-center mt-10 pt-6 border-t border-gray-200">
        <Button
          onClick={prevStep}
          variant="ghost"
          icon={ArrowLeft}
        >
          Atrás
        </Button>
        <Button
          onClick={nextStep}
          icon={ArrowRight}
          disabled={!!state.errors.contact}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
}